import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { getCurrentInstance, onMounted, ref, watch } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { reactive, provide, nextTick } from 'vue';
export default {
  __name: 'App',
  setup: function setup(__props) {
    var sta = reactive({
      isRouterActive: true
    }); // 刷新事件

    function reload() {
      sta.isRouterActive = false;
      nextTick(function () {
        sta.isRouterActive = true;
      });
    }

    provide('reload', reload);
    var store = useStore();
    var app = getCurrentInstance();
    var socketServes = ref({
      socketServe: app.proxy.$SocketService.Instance
    });

    var getCompanyList = function getCompanyList() {
      if (store.getters.token) {
        store.commit('app/setCompany', localStorage.getItem('company_id'));
        store.commit('app/setRegion', localStorage.getItem('region'));
      }
    };

    getCompanyList(); // onMounted(() => {
    //   // 用户需要登录才能开启websokcet
    //   if (store.getters.token) {
    //     socketServes.value.socketServe.connect(store.getters.token)
    //   }
    // })
    // 第一个参数写成数组的形式

    return function (_ctx, _cache) {
      var _component_router_view = _resolveComponent("router-view");

      var _directive_wechat_title = _resolveDirective("wechat-title");

      return sta.isRouterActive ? _withDirectives((_openBlock(), _createBlock(_component_router_view, {
        key: 0
      }, null, 512)), [[_directive_wechat_title, _ctx.$route.meta.title]]) : _createCommentVNode("", true);
    };
  }
};